import React from 'react';
import { isMobile } from 'react-device-detect';

const UnAuthorizedPage = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        fontSize: isMobile ? '20px' : '50px',
        transform: 'translate(0, 40vh)',
      }}
    >
      <p style={{ fontWeight: 600, lineHeight: '40px' }}>401 - Unauthorized</p>
      <p style={{ color: 'red', lineHeight: '40px' }}>Access to this resources is denied</p>
    </div>
  );
};

export default UnAuthorizedPage;
